package map

import js.objects.unsafeJso

fun Style.addSource(id: String, source: Source) {
    if (this.sources == null) this.sources = unsafeJso()
    this.sources!![id] = source
}

fun Style.addLayer(layer: Layer) {
    val layers = this.layers!!
    val newLayers = layers.toMutableList()
    newLayers.add(layer)
    this.layers = newLayers.toTypedArray()
}

fun Style.addLayerAfter(beforeId: String, layer: Layer) {
    val layers = this.layers!!
    val insertIndex = layers.indexOfFirst { it.id == beforeId }
        .takeIf { it >= 0 }?.let { it + 1 } ?: layers.size

    // Insert new layer at position
    val newLayers = layers.toMutableList()
    newLayers.add(insertIndex, layer)
    this.layers = newLayers.toTypedArray()
}

fun Style.findLayer(id: String): Layer? {
    return layers?.find { it.id == id }
}